module.exports = __webpack_public_path__ + "img/student.3e346923.svg";